/**
 * The last complete PPC report day ("data through"), shared by every PPC page.
 *
 * UI overhaul PR-3b (audit PPC-01/02): attributed PPC reports lag Amazon by
 * about two days, so a date range that reaches past the last complete day asks
 * for rows that do not exist yet. `useDateRange` cuts the window at this value
 * (`DateRangePicker.tsx clampRange`) and `PerfSummary` prints it under the
 * KPI strip. PR-2: it is a read of the shared `['freshness','ppc']` query —
 * the same answer the header's health control and the PPC chip show, fetched
 * once for all of them.
 */
import { keys, scopedKey } from './query/keys'
import { queryClient } from './query/queryClient'
import { usePpcFreshness, type PpcFreshness } from './query/freshness'

/** The `YYYY-MM-DD` of the last complete PPC report day, or `null` until known. */
export function usePpcDataThrough(): string | null {
  return usePpcFreshness().data?.last_complete_date ?? null
}

/** Test seam. */
export function _setPpcDataThroughForTests(value: string | null): void {
  const empty: PpcFreshness = {
    last_complete_date: value, last_synced_at: null, is_refreshing: false,
    last_refresh_error: null, current_table: null, tables_total: 0, tables_synced: 0,
    last_refresh_result: null,
  }
  queryClient.setQueryData<PpcFreshness>(scopedKey(keys.freshness.ppc()), (old) =>
    old ? { ...old, last_complete_date: value } : empty)
}
